var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "toolbar"
  }, [_c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.undo"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "undo"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-undo"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.redo"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "redo"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-redo"
  })])]), _c("span", {
    staticClass: "separator"
  }), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.copy"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "copy"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-copy-o"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.paste"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "paste"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-paster-o"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.delete"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "delete"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-delete-o"
  })])]), _c("span", {
    staticClass: "separator"
  }), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.zoomIn"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "zoomIn"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-zoom-in-o"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.zoomOut"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "zoomOut"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-zoom-out-o"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.zoomReset"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "resetZoom"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-actual-size-o"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.autoFit"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "autoFit"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-fit"
  })])]), _c("span", {
    staticClass: "separator"
  }), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.toFront"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "toFront"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-to-front"
  })])]), _c("el-tooltip", {
    attrs: {
      content: this.i18n["tooltip.toBack"],
      placement: "bottom"
    }
  }, [_c("span", {
    staticClass: "command",
    attrs: {
      "data-command": "toBack"
    }
  }, [_c("span", {
    staticClass: "iconfont icon-to-back"
  })])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };